// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2141":"2e9276082f952346","2430":"e8db1ccca43cf2ce","3850":"29f700c02fef17f7","4112":"a3ede44e6a0beb25","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};